module.exports = __webpack_public_path__ + "static/media/icon-hogar-connect-blue.e3ad0e28.png";